import React, { Component } from 'react';
import parse from 'html-react-parser';
// import Moment from 'moment';
import { Container, InputGroup, FormControl, Tab, Nav, Card, Carousel } from 'react-bootstrap';
import { FaMagnifyingGlass, FaArrowRight, FaArrowDown, FaRegCalendarDays, FaRegClock, FaBook } from 'react-icons/fa6';
import { GetText, ReplaceText, SearchList, ReplacePrefixUrl, ReplaceOutputTextHTML } from '../config/helper';
import NumberFormats from '../config/number-format';
import DateTimeFormats from '../config/date-time-format';
import CourseList from '../inc/course/List';
import Loading from '../inc/Loading';
import TagHeaders from '../inc/Headers';
import '../config/global';

const authKey = global.config.kindcode.training[2]+global.config.authBearerKey;

export default class CourseBrowseGuest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      courseList: [],
      courseFeatured: [],
      courseCategories: [],
      isLoad: false,
    }
  }

  componentDidMount() {
    var dataText ='{"keyword":"","pageShow":"10","lang":"'+localStorage.getItem('language')+'","form_id":"pubonly"}';
    var dataSend = JSON.parse(dataText);

    fetch(global.config.urlLink+"/courselist", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': authKey
      }, 
      body : JSON.stringify(dataSend)
    })
    .then(response => {
      if (response.status === 200) {
        return response.json();
      } else {
        console.log('Something happened wrong');
      }
    })
    .then(resultJson => {
      var resultData = [];
      var resultFeatured = [];
      var inum=0;
      if(resultJson.values.length > 0) {
        for (var i in resultJson.values) {
          var content = resultJson.values[i].content;
            if (this.state.courseCategories.indexOf(content.categoryName) < 0) {
              this.state.courseCategories.push(content.categoryName);
            }
            var tutorNames = content.tutorName.replace(',', ', ');
            content.id = resultJson.values[i].docid;
            content.tutorNames = tutorNames;          
            resultData.push(content);
            if (content.isFeatured === "1") {
              resultFeatured.push(content);
            }
            inum++;
            if(inum === resultJson.values.length) {
              this.setState({
                courseList: resultData,
                courseFeatured: resultFeatured,
                isLoad: true
              });
            }
        }
      } else {
        this.setState({
          courseList: resultData,
          isLoad: true
        });
      }
    });
  }

  render() {
    return (
      <div className="browse-course">
        <TagHeaders value={
								{	
									docid: '', 
									title: 'Workshop', 
									description: '',
									links: global.config.urlHost+'/courses'
								}
							}/>
      {
        this.state.courseFeatured.length > 0 ? (
        <>
        <section>
          <Container>
            <h1 className="mb-4">Workshop</h1>
            <p className="mb-5">{GetText() ? "Ikuti pelatihan interaktif dan aplikatif  yang sesuai kebutuhan. Setiap sesi dipandu oleh  ahli yang berpengalaman di bidangnya, baik online maupun tatap muka. Belajar langsung, berdiskusi, dan dapatkan wawasan praktis yang relevan dengan dunia kerja." : "Take interactive and applicable training that suits your needs. Each session is guided by experienced experts in their fields, both online and onsite. Learn directly, engage in discussions, and gain practical insights that are highly relevant to today’s professional landscape."}</p>
            <div className="separator mt-0"><div className="icon"><FaBook className='bg2-secondary'/></div></div>
          </Container>
        </section>
        
        <section>
          <Container>
            <h3>{GetText() ? "Workshop Unggulan" : "Featured Workshop"}</h3>
            <Carousel id="course-featured" slide={true} fade={true} indicators={false}>
            {
                this.state.courseFeatured
                .sort((a,b) => b.courseDate._seconds - a.courseDate._seconds)
                .slice(0,4)
                .map((courseItemFeatured, i) => {
                  return (
                    <Carousel.Item >
                      <div className="row py-4 mb-5">
                        <div className="col-md-4 text-center">
                          <img className="mxw br-8 mb-4" style={{maxHeight:'350px', maxWidth: '420px'}} src={courseItemFeatured.coursePicture} alt={ReplaceText(courseItemFeatured.courseTitle)}/>
                        </div>
                        <div className="col-md-8">
                          <a href={'/course/' + ReplacePrefixUrl(courseItemFeatured.courseTitle) + '/' + courseItemFeatured.id} className="text-dark">
                            <h4 className="mb-3">{parse(ReplaceOutputTextHTML(courseItemFeatured.courseTitle))}</h4>
                          </a>
                          <p style={{height:"65px"}}>{parse(ReplaceOutputTextHTML(courseItemFeatured.courseShortDesc))}</p>
                          <div className="information p-4" style={{height:"180px"}}>
                            <div className="row">
                              <div className="col-md-6">
                                <p>
                                  <strong>{GetText() ? "Tanggal" : "Date"}</strong>
                                  <br/>
                                  <span className="me-2">
                                    <FaRegCalendarDays className="me-1"/>
                                    {courseItemFeatured.courseDate ? DateTimeFormats(courseItemFeatured.courseDate._seconds,"date-long") : ''}
                                  </span>
                                  <span>
                                    <FaRegClock className="me-1"/>
                                    {courseItemFeatured.courseDate ? DateTimeFormats(courseItemFeatured.courseStartTime._seconds,"time-24") : ''}
                                  </span>
                                </p>
                                <p>
                                  <strong>{GetText() ? "Harga" : "Price"}</strong>
                                  <br/>
                                  {courseItemFeatured.courseCurrency === global.config.currency.name[0] ? global.config.currency.symbol[0] : global.config.currency.symbol[1]} 
                                  {NumberFormats(courseItemFeatured.coursePrice)}
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <strong>{GetText() ? "Kategori" : "Category"}</strong>
                                  <br/>
                                  {courseItemFeatured.categoryName}
                                </p>
                                <p>
                                  <strong>{GetText() ? "Pembicara" : "Trainer"}</strong>
                                  <br/>
                                  <div>{courseItemFeatured.tutorNames}</div>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="py-3 text-start">
                            <a href={'/course/' + ReplacePrefixUrl(courseItemFeatured.courseTitle) + '/' + courseItemFeatured.id} className="link-more"><strong>{GetText() ? "Selengkapnya" : "View Details"} <FaArrowRight/></strong></a>
                          </div>
                        </div>
                      </div>
                    </Carousel.Item>
                  )
                })
            }
            </Carousel>
          </Container>
          <div className="separator mt-0"><div className="icon"><FaArrowDown className='bg2-secondary'/></div></div>
        </section>
        </>
        ) : this.state.courseList.length > 0 ? (
          <section>
                <Container>
                  <h1 className="mb-4">Workshop</h1>
                  <p className="mb-5">{GetText() ? "Ikuti pelatihan interaktif dan aplikatif  yang sesuai kebutuhan. Setiap sesi dipandu oleh  ahli yang berpengalaman di bidangnya, baik online maupun tatap muka. Belajar langsung, berdiskusi, dan dapatkan wawasan praktis yang relevan dengan dunia kerja." : "Take interactive and applicable training that suits your needs. Each session is guided by experienced experts in their fields, both online and onsite. Learn directly, engage in discussions, and gain practical insights that are highly relevant to today’s professional landscape."}</p>
                  <div className="separator mt-0"><div className="icon"><FaBook className='bg2-secondary'/></div></div>
                </Container>
          </section>
        ) : (this.state.courseList.length <= 0 && this.state.isLoad === true) ? (
          <div className="mt-5 mb-5">
              <div style={{height:"100px"}}></div>
              <div className="d-flex align-items-center justify-content-center">
                <Card className='card-pop'>
                  <Card.Body className="text-center">
                    <h1 className="mb-4" style={{fontSize:"50pt", color:"#DC3545"}}>COMING SOON</h1>
                    <p style={{fontSize:"13pt", color:"#595959"}}>{GetText() ?  `Tetaplah bersama kami. Hal yang menarik akan segera hadir. \nJadilah yang pertama mengetahuinya.` : `Stay tuned. Something awesome is coming soon. \nBe the first to know.` } </p>
                  </Card.Body>
                </Card>
              </div>
              <div style={{height:"200px"}}></div>
            </div>

        ) : <Loading value={{id:'course-area', type: 'screen'}}/> 
      }
      { this.state.courseList.length > 0 ? (
        <section>
          <Container>
            <div className="row py-4">
              <Tab.Container defaultActiveKey="category-all">
                <div className="col-md-3">
                  <div className="sidebar-tab sticky-top">
                    <h3 className="mb-4">{GetText() ? "Pencarian" : "Search"}</h3>
                    <InputGroup className="mb-5">
                      <FormControl placeholder={GetText() ? "Ketik di sini..." : "Type here..."} aria-label="Course" aria-describedby="search" id="search" onKeyUp={SearchList}/>
                      {/* <InputGroup.Append> */}
                        <InputGroup.Text><FaMagnifyingGlass/></InputGroup.Text>
                      {/* </InputGroup.Append> */}
                    </InputGroup>
                    <h3 className="mb-4">{GetText() ? "Kategori" : "Category"}</h3>
                    <Nav variant="pills" className="nav-scroll flex-column">
                      <Nav.Item key="all">
                        <Nav.Link eventKey="category-all">{GetText() ? "Semua" : "All"}</Nav.Link>
                      </Nav.Item>
                      {
                        this.state.courseCategories
                        .sort((a, b) => { return (a < b) ? -1 : ((a > b) ? 1 : 0) })
                        .map((courseCategory, i) => {
                          return (
                            <Nav.Item key={i}>
                              <Nav.Link eventKey={"category-" + i}>{courseCategory}</Nav.Link>
                            </Nav.Item>
                          )
                        })
                      }
                    </Nav>
                  </div>
                </div>
                <div className="col-md-1"></div>
                <div className="col-md-8 bg-light p-5 br-8">
                  <h3 className="mb-4">{GetText() ? "Daftar Workshop" : "Workshop List"}</h3>
                  <Tab.Content>
                    <Tab.Pane eventKey="category-all" key="all">
                      {
                        this.state.courseList
                          .sort((a, b) => b.courseDate._seconds - a.courseDate._seconds)
                          .map((courseItem, i) => {
                          return (
                            <CourseList value={courseItem} key={i}/>
                          )
                        })
                      }
                    </Tab.Pane>
                    {
                      this.state.courseCategories.map((courseCategory, i) => {
                        return (
                          <Tab.Pane eventKey={"category-" + i} key={i}>
                            {
                              this.state.courseList
                              .sort((a, b) => b.courseDate._seconds - a.courseDate._seconds)
                              .filter(courseItem => courseItem.categoryName === courseCategory)
                              .map((courseItem, j) => {
                                return (
                                  <CourseList value={courseItem} key={j}/>
                                )
                              })
                            }
                          </Tab.Pane>
                        )
                      })
                    }
                  </Tab.Content>
                </div>
              </Tab.Container>
            </div>
          </Container>
        </section>
        ) : <></>
      }
      </div>
    );
  }
}